export default "__VITE_ASSET__DNd5FMNA__"